<template>
  <div class="performance-container">


    <!-- 搜索筛选区域 -->
    <div class="search-card">
      <el-card shadow="never" class="search-form-card">
        <div slot="header" class="search-header">
          <span class="search-title">
            <i class="el-icon-search"></i>
            筛选条件
          </span>
        </div>
        <el-form
          :model="searchForm.formData"
          :inline="true"
          size="small"
          class="search-form"
        >
          <el-form-item label="姓名" prop="name">
            <el-input
              placeholder="请输入员工姓名"
              v-model.trim="searchForm.formData.name"
              prefix-icon="el-icon-user"
              clearable
              style="width: 200px"
            />
          </el-form-item>
          <el-form-item label="部门" prop="deptId">
            <el-select
              placeholder="请选择部门"
              v-model="searchForm.formData.deptId"
              clearable
              style="width: 200px"
            >
              <el-option
                v-for="option in searchForm.deptList"
                :key="option.id"
                :label="option.name"
                :value="option.id"
                :disabled="option.disabled"
              />
            </el-select>
          </el-form-item>
          <el-form-item label="月份" prop="month">
            <el-date-picker
              value-format='yyyyMM'
              type="month"
              placeholder='请选择月份'
              v-model="searchForm.formData.month"
              style="width: 200px"
            />
          </el-form-item>
          <el-form-item label="部门类型" prop="driverFilter">
            <el-select
              placeholder="请选择部门类型"
              v-model="searchForm.formData.driverFilter"
              clearable
              style="width: 200px"
            >
              <el-option
                label="全部"
                value=""
              />
              <el-option
                label="司机部门"
                value="driver"
              />
              <el-option
                label="其他部门"
                value="other"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search" icon="el-icon-search">
              搜索
            </el-button>
            <el-button @click="reset" icon="el-icon-refresh-left">
              重置
            </el-button>
          </el-form-item>
        </el-form>

        <!-- 显示控制开关 -->
        <div class="switch-section">
          <el-switch
            v-model="flag1"
            active-text="显示打卡记录"
            inactive-text="隐藏打卡记录"
            @change="handleStatusChange"
            active-color="#409EFF"
          />
          <el-switch
            v-model="showShiftInfo"
            active-text="显示班次信息"
            inactive-text="隐藏班次信息"
            @change="handleShiftDisplayChange"
            active-color="#67C23A"
            style="margin-left: 20px;"
          />
          <el-switch
            v-model="showNormalRecords"
            active-text="显示正常记录"
            inactive-text="隐藏正常记录"
            @change="handleNormalDisplayChange"
            active-color="#E6A23C"
            style="margin-left: 20px;"
          />
        </div>
      </el-card>
    </div>

    <!-- 数据表格区域 -->
    <div class="table-card">
      <el-card shadow="never" class="table-card-content">
        <div class="table-header">
          <div class="table-title">
            <i class="el-icon-s-grid"></i>
            考勤数据列表
            <el-tag v-if="month" type="info" size="small" class="month-tag">
              {{ month }}
            </el-tag>
          </div>
          <div class="table-stats">
            <span class="stats-text">
              共 {{ table.pageConfig.total }} 条记录
            </span>
          </div>
        </div>

        <div class="table-container">
          <el-table
            ref="multipleTable"
            v-loading="loading1"
            element-loading-text="数据加载中..."
            element-loading-spinner="el-icon-loading"
            :data="table.tableData"
            height="calc(100vh - 400px)"
            border
            stripe
            row-key="id"
            :header-cell-style="headerCellStyle"
            :row-style="rowStyle"
            class="performance-table"
          >
            <el-table-column prop="code" label="工号" width="120" align="center" fixed="left">
              <template slot-scope="scope">
                <el-tag type="info" size="small">{{ scope.row.code }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column label="姓名" width="120" align="center" fixed="left">
              <template slot-scope="scope">
                <el-popover trigger="click" placement="top" width="200">
                  <div class="avatar-preview">
                    <el-image
                      style="width: 200px; height: 200px"
                      :preview-src-list="scope.row.faceList === null ? 'https://hjgc.xkyun.top/img/avatar.1343ffb8.png' : scope.row.faceList.split(';')[0]"
                      :src="scope.row.faceList === null ? 'https://hjgc.xkyun.top/img/avatar.1343ffb8.png' : scope.row.faceList.split(';')[0]"
                      fit="cover"
                    />
                  </div>
                  <div slot="reference" class="name-wrapper">
                    <el-avatar
                      :size="32"
                      :src="scope.row.faceList === null ? 'https://hjgc.xkyun.top/img/avatar.1343ffb8.png' : scope.row.faceList.split(';')[0]"
                      />
                    <span class="name-text">{{ scope.row.name }}</span>
                  </div>
                </el-popover>
              </template>
            </el-table-column>

            <el-table-column prop="deptName" label="部门" width="120" align="center" fixed="left">
              <template slot-scope="scope">
                <el-tag type="success" size="small">{{ scope.row.deptName }}</el-tag>
              </template>
            </el-table-column>

            <el-table-column prop="phone" label="电话" width="130" align="center" fixed="left">
              <template slot-scope="scope">
                <span class="phone-text">{{ scope.row.phone }}</span>
              </template>
            </el-table-column>

            <!-- 班次列 -->
            <el-table-column
              v-if="showShiftInfo"
              :label="getCurrentMonthName()"
              width="120"
              align="center"
              fixed="left"
            >
              <template slot-scope="scope">
                <div class="shift-display">
                  <el-tag
                    :type="getShiftTagType(scope.row.shiftType)"
                    size="small"
                    class="shift-tag"
                  >
                    <i :class="getShiftIcon(scope.row.shiftType)"></i>
                    {{ getShiftName(scope.row.shiftType) }}
                  </el-tag>
                  <div class="shift-time" v-if="scope.row.shiftTime">
                    {{ scope.row.shiftTime }}
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              v-for="index in dayNum"
              :label="index+'日'"
              :key="index"
              width="120"
              align="center"
            >
              <template slot-scope="scope">
                <div class="attendance-cell" @click="changeStatus(scope.row,index-1)">
                  <!-- 考勤状态 -->
                  <el-tag
                    v-if="showNormalRecords || scope.row.attendanceList[index-1].message !== '正常'"
                    :type="scope.row.attendanceList[index-1].tagType"
                    size="small"
                    class="attendance-tag"
                  >
                    {{ scope.row.attendanceList[index - 1].message }}
                  </el-tag>

                  <!-- 班次信息 -->
                  <div v-if="showShiftInfo && scope.row.attendanceList[index-1].shift_type" class="daily-shift-info">
                    <el-tag
                      :type="getShiftTagType(scope.row.attendanceList[index-1].shift_type)"
                      size="mini"
                      class="daily-shift-tag"
                    >
                      <i :class="getShiftIcon(scope.row.attendanceList[index-1].shift_type)"></i>
                      {{ scope.row.attendanceList[index-1].shift_desc || getShiftName(scope.row.attendanceList[index-1].shift_type) }}
                    </el-tag>
                  </div>

                  <!-- 打卡状态 -->
                  <div v-if="flag1 && scope.row.attendanceList[index-1].message === '正常'" class="checkin-status">
                    <el-tag
                      :type="scope.row.attendanceList[index-1].checkin_status_type || 'info'"
                      size="mini"
                    >
                      {{ scope.row.attendanceList[index-1].checkin_status || '未知' }}
                    </el-tag>
                  </div>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <!-- 分页器 -->
        <div class="pagination-container">
          <el-pagination
            layout="total, sizes, prev, pager, next, jumper"
            :page-size="table.pageConfig.size ? table.pageConfig.size : 10"
            :page-sizes="[10, 20, 50, 200, 400]"
            :total="table.pageConfig.total"
            :current-page.sync="table.pageConfig.current"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            background
          />
        </div>
      </el-card>
    </div>

    <!-- 页面标题和操作区域 -->
    <div class="page-header">
      <div class="header-content">
        <div class="title-section">
          <h2 class="page-title">
            <i class="el-icon-data-line"></i>
            考勤绩效管理
          </h2>
          <p class="page-subtitle">员工考勤状态统计与绩效分析</p>
        </div>
        <div class="action-buttons">
          <el-button
            type="warning"
            size="small"
            @click="exportData"
            icon="el-icon-download"
          >
            导出数据
          </el-button>
        </div>
      </div>
    </div>

    <!-- 考勤状态修改对话框 -->
    <el-dialog
      title="修改考勤状态"
      :visible.sync="dialog.isShow"
      width="500px"
      :close-on-click-modal="false"
      class="status-dialog"
    >
      <div class="dialog-content">
        <div class="dialog-info">
          <p><strong>员工：</strong>{{ dialog.data.staffName || '未知' }}</p>
          <p><strong>日期：</strong>{{ dialog.data.attendanceDate || '未知' }}</p>
          <p v-if="showShiftInfo && dialog.data.shift_type">
            <strong>{{ getCurrentMonthName() }}：</strong>
            <el-tag
              :type="getShiftTagType(dialog.data.shift_type)"
              size="small"
              class="dialog-shift-tag"
            >
              <i :class="getShiftIcon(dialog.data.shift_type)"></i>
              {{ dialog.data.shift_desc || getShiftName(dialog.data.shift_type) }}
            </el-tag>
          </p>
        </div>
        <el-radio-group v-model="dialog.status" class="status-radio-group">
          <el-radio
            v-for="(item,index) in dialog.statusList"
            :key="index"
            :label="item.message"
            border
            class="status-radio"
          >
            {{ item.message }}
          </el-radio>
        </el-radio-group>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog.isShow = false">取消</el-button>
        <el-button type="primary" @click="confirm" :loading="dialog.loading">
          确定
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getAll, getByStaffIdAndDate, getExportApi, getImportApi, getList, setAttendance } from '../../../api/attendance'
import { mapState } from 'vuex'
import { getAllDept } from '@/api/dept'

export default {
  name: 'Performance',
  data () {
    return {
      flag1: false,
      showShiftInfo: false, // 班次信息显示开关，默认显示
      showNormalRecords: true, // 正常记录显示开关，默认显示
      loading1: false,
      dialog: {
        isShow: false,
        data: {},
        status: '',
        statusList: [],
        loading: false
      },
      searchForm: {
        deptList: [],
        formData: {}
      },
      table: {
        tableData: [],
        pageConfig: {
          total: 10, // 记录总数
          current: 1, // 起始页
          size: 10 // 每页展示的记录数
        }
      },
      dayNum: 0,
      month: '',
      // 班次类型配置
      shiftTypes: {
        'DAY_SHIFT': { name: '白班', icon: 'el-icon-sunny', color: 'success', time: '4:40-5:50,18:00-18:50' },
        'NIGHT_SHIFT': { name: '夜班', icon: 'el-icon-moon', color: 'info', time: '16:40-17:50,6:00-6:50' },
        'MORNING': { name: '早班', icon: 'el-icon-sunrise', color: 'warning', time: '早班时间' },
        'AFTERNOON': { name: '中班', icon: 'el-icon-sunny', color: 'primary', time: '中班时间' },
        'ALL_DAY': { name: '全天', icon: 'el-icon-time', color: 'success', time: '全天班次' },
        'UNKNOWN': { name: '未知班次', icon: 'el-icon-question', color: 'danger', time: '未知时间' }
      }
    }
  },
  computed: {
    ...mapState('token', ['token']),
    headers () {
      return { token: this.token }
    },
    // 获取导入数据的接口
    importApi () {
      return getImportApi()
    },
    // 表格头部样式
    headerCellStyle () {
      return {
        background: '#f0f9ff',
        color: '#333333',
        textAlign: 'center',
        fontWeight: 'bold',
        fontSize: '14px',
        borderWidth: '1px',
        borderColor: '#e4e7ed'
      }
    },
    // 表格行样式
    rowStyle () {
      return {
        height: '60px'
      }
    }
  },
  methods: {
    // 获取班次名称
    getShiftName (shiftType) {
      return this.shiftTypes[shiftType]?.name || '未知班次'
    },
    // 获取班次图标
    getShiftIcon (shiftType) {
      return this.shiftTypes[shiftType]?.icon || 'el-icon-question'
    },
    // 获取班次标签类型
    getShiftTagType (shiftType) {
      return this.shiftTypes[shiftType]?.color || 'info'
    },
    // 为员工添加班次信息（从考勤记录中推断）
    addEmployeeShiftInfo (staffList) {
      return staffList.map(staff => {
        // 基于日期和倒班规律统计班次信息
        const shiftInfo = this.calculateShiftInfoByDate(staff.attendanceList)

        return {
          ...staff,
          shiftType: shiftInfo.mainShiftType,
          shiftInfo: {
            type: shiftInfo.mainShiftType,
            name: this.getShiftName(shiftInfo.mainShiftType),
            details: shiftInfo.details
          }
        }
      })
    },

    // 基于当前日期动态计算班次信息
    calculateShiftInfoByDate (attendanceList) {
      if (!attendanceList || attendanceList.length === 0) {
        return {
          mainShiftType: 'UNKNOWN',
          details: {
            dayShiftDays: 0,
            nightShiftDays: 0,
            unknownDays: 0,
            totalDays: 0,
            currentMonth: this.getCurrentMonthName()
          }
        }
      }

      // 获取当前日期
      const today = new Date()
      const currentDay = today.getDate()
      const currentMonth = today.getMonth() + 1
      const currentYear = today.getFullYear()

      let dayShiftDays = 0
      let nightShiftDays = 0
      let unknownDays = 0
      let totalDays = 0

      // 根据当前日期确定统计范围
      let startDay, endDay
      if (currentDay <= 15) {
        // 1-15号：统计1号到当前日期的班次
        startDay = 1
        endDay = currentDay
      } else {
        // 16-31号：统计16号到当前日期的班次
        startDay = 16
        endDay = currentDay
      }


      console.log(attendanceList)
      // 按日期统计班次（只统计当前统计范围内的日期）
      attendanceList.forEach(attendance => {
        if (attendance.shift_type && attendance.shift_type !== 'UNKNOWN') {
          // console.log(attendance.date);
          const attendanceDate = this.parseAttendanceDate(attendance.attendanceDate)
          // console.log(attendanceDate)
          if (attendanceDate && this.isInCurrentRange(attendanceDate, currentYear, currentMonth, startDay, endDay)) {
            totalDays++

            // 统计实际班次
            if (attendance.shift_type === 'DAY_SHIFT') {
              dayShiftDays++
            } else if (attendance.shift_type === 'NIGHT_SHIFT') {
              nightShiftDays++
            } else {
              unknownDays++
            }
          }
        }
      })
      // console.log(totalDays)
      // console.log(dayShiftDays);
      // console.log(nightShiftDays);

      // 确定主要班次类型
      let mainShiftType = 'UNKNOWN'
      if (totalDays > 0) {
        if (dayShiftDays > nightShiftDays) {
          mainShiftType = 'DAY_SHIFT'
        } else if (nightShiftDays > dayShiftDays) {
          mainShiftType = 'NIGHT_SHIFT'
        } else if (dayShiftDays === nightShiftDays && dayShiftDays > 0) {
          // 如果白班和夜班天数相等，根据最近几天的班次判断
          mainShiftType = this.getRecentShiftType(attendanceList, currentYear, currentMonth, startDay, endDay)
        }
      }

      return {
        mainShiftType,
        details: {
          dayShiftDays,
          nightShiftDays,
          unknownDays,
          totalDays,
          currentMonth: this.getCurrentMonthName(),
          rangeInfo: {
            startDay,
            endDay,
            isFirstHalf: currentDay <= 15
          }
        }
      }
    },

    // 根据日期获取期望的班次类型（基于1号和15号倒班规律）
    getExpectedShiftTypeByDate (dateStr) {
      if (!dateStr) return 'UNKNOWN'

      try {
        // 解析日期字符串，支持多种格式
        let date
        if (dateStr.includes('-')) {
          // YYYY-MM-DD 格式
          date = new Date(dateStr)
        } else if (dateStr.length === 8) {
          // YYYYMMDD 格式
          const year = dateStr.substring(0, 4)
          const month = dateStr.substring(4, 6)
          const day = dateStr.substring(6, 8)
          date = new Date(year, month - 1, day)
        } else {
          return 'UNKNOWN'
        }

        const day = date.getDate()

        // 1号中午和15号中午倒班
        // 1-15号：白班，16-31号：夜班
        if (day >= 1 && day <= 15) {
          return 'DAY_SHIFT'
        } else if (day >= 16 && day <= 31) {
          return 'NIGHT_SHIFT'
        } else {
          return 'UNKNOWN'
        }
      } catch (error) {
        console.error('日期解析失败:', dateStr, error)
        return 'UNKNOWN'
      }
    },

    // 获取最近几天的班次类型（用于处理白班夜班天数相等的情况）
    getRecentShiftType (attendanceList, currentYear, currentMonth, startDay, endDay) {
      if (!attendanceList || attendanceList.length === 0) return 'UNKNOWN'

      // 在统计范围内取最近3天的数据
      const recentDays = attendanceList.filter(attendance => {
        const attendanceDate = this.parseAttendanceDate(attendance.date)
        return attendanceDate && this.isInCurrentRange(attendanceDate, currentYear, currentMonth, startDay, endDay)
      }).slice(-3)

      let dayShiftCount = 0
      let nightShiftCount = 0

      recentDays.forEach(attendance => {
        if (attendance.shift_type === 'DAY_SHIFT') {
          dayShiftCount++
        } else if (attendance.shift_type === 'NIGHT_SHIFT') {
          nightShiftCount++
        }
      })

      if (dayShiftCount > nightShiftCount) {
        return 'DAY_SHIFT'
      } else if (nightShiftCount > dayShiftCount) {
        return 'NIGHT_SHIFT'
      } else {
        return 'UNKNOWN'
      }
    },

    // 解析考勤日期
    parseAttendanceDate (dateStr) {
      if (!dateStr) return null

      try {
        let date
        if (dateStr.includes('-')) {
          // YYYY-MM-DD 格式
          date = new Date(dateStr)
        } else if (dateStr.length === 8) {
          // YYYYMMDD 格式
          const year = dateStr.substring(0, 4)
          const month = dateStr.substring(4, 6)
          const day = dateStr.substring(6, 8)
          date = new Date(year, month - 1, day)
        } else {
          return null
        }
        return date
      } catch (error) {
        console.error('日期解析失败:', dateStr, error)
        return null
      }
    },

    // 判断日期是否在当前统计范围内
    isInCurrentRange (date, currentYear, currentMonth, startDay, endDay) {
      const year = date.getFullYear()
      const month = date.getMonth() + 1
      const day = date.getDate()

      return year === currentYear &&
             month === currentMonth &&
             day >= startDay &&
             day <= endDay
    },

    // 获取当前月份名称
    getCurrentMonthName () {
      const monthNames = [
        '一月', '二月', '三月', '四月', '五月', '六月',
        '七月', '八月', '九月', '十月', '十一月', '十二月'
      ]
      const currentMonth = new Date().getMonth()
      return monthNames[currentMonth] + '班次'
    },
    handleStatusChange () {
      // 打卡信息显示开关变化时，不需要重新加载数据
      // 只需要重新布局表格即可
      this.$nextTick(() => {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.doLayout()
        }
      })
    },
    // 处理班次显示开关变化
    handleShiftDisplayChange () {
      // 班次显示开关变化时，不需要重新加载数据
      // 只需要重新布局表格即可
      this.$nextTick(() => {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.doLayout()
        }
      })
    },
    // 处理正常记录显示开关变化
    handleNormalDisplayChange () {
      // 正常记录显示开关变化时，不需要重新加载数据
      // 只需要重新布局表格即可
      this.$nextTick(() => {
        if (this.$refs.multipleTable) {
          this.$refs.multipleTable.doLayout()
        }
      })
    },
    confirm () {
      this.dialog.loading = true
      this.dialog.data.status = this.dialog.status
      setAttendance(this.dialog.data).then(response => {
        if (response.code === 200) {
          this.loading()
          this.$message.success('修改成功')
          this.dialog.isShow = false
          this.$nextTick(() => {
            this.$refs.multipleTable.doLayout();
          });
        } else {
          this.$message.error('修改失败')
        }
      }).finally(() => {
        this.dialog.loading = false
      })
    },
    changeStatus (row, i) {
      getAll().then(response => {
        if (response.code === 200) {
          this.dialog.statusList = response.data
        } else {
          this.$message.error('获取数据失败')
        }
      })
      getByStaffIdAndDate(row.staffId, row.attendanceList[i].attendanceDate).then(response => {
        if (response.code === 200) {
          this.dialog.data = {
            ...response.data,
            shift_type: row.attendanceList[i].shift_type,
            shift_desc: row.attendanceList[i].shift_desc
          }
        } else {
          this.dialog.data = {
            staffId: row.staffId,
            attendanceDate: row.attendanceList[i].attendanceDate,
            staffName: row.name,
            shift_type: row.attendanceList[i].shift_type,
            shift_desc: row.attendanceList[i].shift_desc
          }
        }
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout();
        });
      })
      this.dialog.isShow = true
      this.dialog.status = row.attendanceList[i].message
    },
    handleSizeChange (size) {
      this.table.pageConfig.size = size
      this.loading()
    },
    handleCurrentChange (current) {
      this.table.pageConfig.current = current
      this.loading()
    },
    search () {
      this.loading()
    },
    // 重置搜索表单
    reset () {
      this.searchForm.formData = {}
      this.loading()
    },
    // 将数据渲染到模板
    loading () {
      this.loading1 = true
      getAllDept(this.$store.state.staff.staff.deptId).then(response => {
        const list = []
        response.data.forEach(dept => {
          if (dept.children.length > 0) {
            dept.disabled = true
            list.push(dept)
            dept.children.forEach(subDept => {
              list.push(subDept)
            })
          }
        })
        this.searchForm.deptList = list
      })
      getList({
        current: this.table.pageConfig.current,
        size: this.table.pageConfig.size,
        name: this.searchForm.formData.name,
        deptId: this.searchForm.formData.deptId,
        month: this.searchForm.formData.month,
        myDeptId: this.$store.state.staff.staff.deptId,
        driverFilter: this.searchForm.formData.driverFilter
      }).then(response => {
        if (response.code === 200) {
          // 直接使用后端返回的数据，后端已经包含了班次信息
          // 为每个员工添加主要班次信息（从考勤记录中推断）
          this.table.tableData = this.addEmployeeShiftInfo(response.data.list)
          this.table.pageConfig.total = response.data.total
          this.dayNum = response.data.dayNum
          this.month = response.data.month
        } else {
          this.$message.error(response.message)
        }
        this.loading1 = false
        this.$nextTick(() => {
          this.$refs.multipleTable.doLayout();
        });
      })
    },
    // 导出数据
    exportData () {
      window.open(getExportApi(this.month, this.$store.state.staff.staff.deptId))
    },
    handleImportSuccess (response) {
      if (response.code === 200) {
        this.$message.success('数据导入成功！')
        this.loading()
      } else {
        this.$message.error('数据导入失败！')
      }
    }
  },
  created () {
    this.loading()
  }
}
</script>
<style lang="less" scoped>
.performance-container {
  padding: 20px;
  background: #f5f7fa;
  min-height: 100vh;
}

/* 页面头部样式 */
.page-header {
  margin-bottom: 20px;

  .header-content {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 24px 32px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(102, 126, 234, 0.3);

    .title-section {
      .page-title {
        color: #ffffff;
        font-size: 28px;
        font-weight: 600;
        margin: 0 0 8px 0;
        display: flex;
        align-items: center;

        i {
          margin-right: 12px;
          font-size: 32px;
        }
      }

      .page-subtitle {
        color: rgba(255, 255, 255, 0.8);
        font-size: 14px;
        margin: 0;
      }
    }

    .action-buttons {
      .el-button {
        border-radius: 8px;
        padding: 12px 24px;
        font-weight: 500;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
      }
    }
  }
}

/* 搜索卡片样式 */
.search-card {
  margin-bottom: 20px;

  .search-form-card {
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid #e4e7ed;

    .search-header {
      .search-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        display: flex;
        align-items: center;

        i {
          margin-right: 8px;
          color: #409EFF;
        }
      }
    }

    .search-form {
      margin-bottom: 16px;

      .el-form-item {
        margin-right: 20px;
        margin-bottom: 16px;

        .el-input, .el-select, .el-date-picker {
          border-radius: 6px;
        }
      }
    }

    .switch-section {
      padding: 16px 0;
      border-top: 1px solid #f0f0f0;
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      gap: 20px;

      .el-switch {
        .el-switch__label {
          font-weight: 500;
          font-size: 14px;
        }

        .el-switch__core {
          border-radius: 20px;
        }
      }
    }
  }
}

/* 表格卡片样式 */
.table-card {
  .table-card-content {
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    border: 1px solid #e4e7ed;

    .table-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 20px;
      padding-bottom: 16px;
      border-bottom: 2px solid #f0f0f0;

      .table-title {
        font-size: 18px;
        font-weight: 600;
        color: #303133;
        display: flex;
        align-items: center;

        i {
          margin-right: 8px;
          color: #409EFF;
        }

        .month-tag {
          margin-left: 12px;
        }
      }

      .table-stats {
        .stats-text {
          color: #909399;
          font-size: 14px;
        }
      }
    }

    .table-container {
      .performance-table {
        border-radius: 8px;
        overflow: hidden;

        .el-table__header {
          th {
            background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
            color: #ffffff !important;
            font-weight: 600;
            border: none;
          }
        }

        .el-table__body {
          tr {
            &:hover {
              background-color: #f8f9ff;
            }
          }
        }
      }
    }

    .pagination-container {
      margin-top: 20px;
      display: flex;
      justify-content: center;
      padding: 20px 0;
    }
  }
}

/* 表格单元格样式 */
.name-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;

  &:hover {
    transform: scale(1.05);
  }

  .name-text {
    margin-left: 8px;
    font-weight: 500;
    color: #303133;
  }
}

.phone-text {
  color: #606266;
  font-size: 13px;
}

/* 班次显示样式 */
.shift-display {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;

  .shift-tag {
    display: flex;
    align-items: center;
    gap: 4px;
    font-weight: 500;
    border-radius: 6px;
    padding: 4px 8px;

    i {
      font-size: 12px;
    }
  }

  .shift-time {
    font-size: 11px;
    color: #909399;
    background: #f5f7fa;
    padding: 2px 6px;
    border-radius: 4px;
    white-space: nowrap;
  }
}

/* 每日班次显示样式 */
.daily-shift-info {
  margin-top: 4px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;

  .daily-shift-tag {
    display: flex;
    align-items: center;
    gap: 2px;
    font-size: 10px;
    padding: 2px 4px;
    border-radius: 4px;
    font-weight: 500;

    i {
      font-size: 10px;
    }
  }

  .daily-shift-time {
    font-size: 9px;
    color: #909399;
    background: #f0f2f5;
    padding: 1px 4px;
    border-radius: 3px;
    white-space: nowrap;
    text-align: center;
  }
}

.attendance-cell {
  cursor: pointer;
  padding: 4px;
  border-radius: 6px;
  transition: all 0.3s ease;
  min-height: 30px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 3px;

  &:hover {
    background-color: #f0f9ff;
    transform: translateY(-1px);
  }

  .attendance-tag {
    margin-bottom: 2px;
    font-weight: 500;
    order: 1;
  }

  .daily-shift-info {
    order: 2;
    margin: 2px 0;
  }

  .checkin-status {
    margin-top: 2px;
    order: 3;
  }
}

.avatar-preview {
  text-align: center;

  .el-image {
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }
}

/* 对话框样式 */
.status-dialog {
  .dialog-content {
    .dialog-info {
      background: #f8f9fa;
      padding: 16px;
      border-radius: 8px;
      margin-bottom: 20px;

      p {
        margin: 8px 0;
        color: #606266;

        strong {
          color: #303133;
        }

        .dialog-shift-tag {
          margin-left: 8px;
          display: inline-flex;
          align-items: center;
          gap: 4px;

          i {
            font-size: 12px;
          }
        }

        .shift-time-text {
          margin-left: 8px;
          color: #909399;
          font-size: 12px;
        }
      }
    }

    .status-radio-group {
      display: flex;
      flex-wrap: wrap;
      gap: 12px;

      .status-radio {
        margin-right: 0;
        margin-bottom: 12px;

        .el-radio__label {
          font-weight: 500;
        }
      }
    }
  }

  .dialog-footer {
    text-align: right;

    .el-button {
      border-radius: 6px;
      padding: 10px 20px;
      font-weight: 500;
    }
  }
}

/* 响应式设计 */
@media (max-width: 768px) {
  .performance-container {
    padding: 12px;
  }

  .page-header .header-content {
    flex-direction: column;
    align-items: flex-start;
    gap: 16px;
  }

  .search-form {
    .el-form-item {
      margin-right: 0;
      width: 100%;

      .el-input, .el-select, .el-date-picker {
        width: 100% !important;
      }
    }
  }

  .table-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }
}

/* 加载动画优化 */
.el-loading-mask {
  background-color: rgba(255, 255, 255, 0.9);
}

/* 标签样式优化 */
.el-tag {
  border-radius: 4px;
  font-weight: 500;

  &.el-tag--success {
    background-color: #f0f9ff;
    border-color: #67c23a;
    color: #67c23a;
  }

  &.el-tag--info {
    background-color: #f4f4f5;
    border-color: #909399;
    color: #909399;
  }

  &.el-tag--danger {
    background-color: #fef0f0;
    border-color: #f56c6c;
    color: #f56c6c;
  }

  &.el-tag--warning {
    background-color: #fdf6ec;
    border-color: #e6a23c;
    color: #e6a23c;
  }

  &.el-tag--primary {
    background-color: #ecf5ff;
    border-color: #409eff;
    color: #409eff;
  }
}

/* 班次标签特殊样式 */
.shift-tag {
  &.el-tag--success {
    background: linear-gradient(135deg, #67c23a, #85ce61);
    color: #ffffff;
    border: none;
    box-shadow: 0 2px 4px rgba(103, 194, 58, 0.3);
  }

  &.el-tag--info {
    background: linear-gradient(135deg, #909399, #a6a9ad);
    color: #ffffff;
    border: none;
    box-shadow: 0 2px 4px rgba(144, 147, 153, 0.3);
  }

  &.el-tag--warning {
    background: linear-gradient(135deg, #e6a23c, #ebb563);
    color: #ffffff;
    border: none;
    box-shadow: 0 2px 4px rgba(230, 162, 60, 0.3);
  }

  &.el-tag--primary {
    background: linear-gradient(135deg, #409eff, #66b1ff);
    color: #ffffff;
    border: none;
    box-shadow: 0 2px 4px rgba(64, 158, 255, 0.3);
  }

  &.el-tag--danger {
    background: linear-gradient(135deg, #f56c6c, #f78989);
    color: #ffffff;
    border: none;
    box-shadow: 0 2px 4px rgba(245, 108, 108, 0.3);
  }
}

/* 分页器样式优化 */
.el-pagination {
  .el-pagination__total,
  .el-pagination__sizes,
  .el-pagination__jump {
    font-weight: 500;
  }

  .el-pager li {
    border-radius: 4px;
    margin: 0 2px;

    &.active {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: #ffffff;
    }
  }

  .btn-prev,
  .btn-next {
    border-radius: 4px;
  }
}
</style>
